import { create } from 'zustand'

export interface AssessmentsFilter {
  employeeName?: string
  employeeUserIds?: string
  status?: string
  dateFrom?: string
  dateTo?: string
}

interface AssessmentsFilterState {
  filters: AssessmentsFilter
  setFilters: (filters: Partial<AssessmentsFilter>) => void
  resetFilters: () => void
  setEmployeeName: (employeeName: string | undefined) => void
  setEmployeeUserIds: (employeeUserIds: string | undefined) => void
  setStatus: (status: string | undefined) => void
  setDateFrom: (dateFrom: string | undefined) => void
  setDateTo: (dateTo: string | undefined) => void
}

const initialFilters: AssessmentsFilter = {
  employeeName: undefined,
  employeeUserIds: undefined,
  status: undefined,
  dateFrom: undefined,
  dateTo: undefined,
}

export const useAssessmentsFilterStore = create<AssessmentsFilterState>(
  (set) => ({
    filters: initialFilters,

    setFilters: (newFilters) =>
      set((state) => ({
        filters: { ...state.filters, ...newFilters },
      })),

    resetFilters: () =>
      set({
        filters: initialFilters,
      }),

    setEmployeeName: (employeeName) =>
      set((state) => ({
        filters: { ...state.filters, employeeName },
      })),

    setEmployeeUserIds: (employeeUserIds) =>
      set((state) => ({
        filters: { ...state.filters, employeeUserIds },
      })),

    setStatus: (status) =>
      set((state) => ({
        filters: { ...state.filters, status },
      })),

    setDateFrom: (dateFrom) =>
      set((state) => ({
        filters: { ...state.filters, dateFrom },
      })),

    setDateTo: (dateTo) =>
      set((state) => ({
        filters: { ...state.filters, dateTo },
      })),
  }),
)
